<template>
  <b-button
    class="button_clear_filter"
    type="is-text"
    :size="size"
    @click="$emit('click', $event)"
  >
    reload
  </b-button>
</template>

<script>
export default {
  name: "FilterButtonReload",
  props: {
    size: {
      type: String,
      default: 'is-small'
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.button_clear_filter {
  margin-right: 10px;
  color: $secondary;
}
</style>
